import { Dispatch } from 'redux';

import { MainStore } from '../store';

import collectionHandlers from './modules/collection';
import initHandler from './modules/init';
import locationHandlers from './modules/location';
import { routerAfterHandlers } from './modules/router';

const handlers: Record<string, unknown> = {
    ...initHandler,
    ...locationHandlers,
    ...collectionHandlers,
    ...routerAfterHandlers,
};

export default (store: MainStore) =>
    (next: Dispatch) =>
    (action: { type: keyof typeof handlers }): void => {
        next(action);

        if (action.type in handlers) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            handlers[action.type](store, action);
        }
    };
